<div class="bg-white p-2">
    <div class="row bg-white ml-auto">
        <div>
            <label>Inizio</label>
            <input class="form-control" (change)="Refresh()" type="date" [(ngModel)]="filtro.inizio"  [ngModelOptions]="{updateOn: 'change'}">
        </div>
        <div class="ml-2">
            <label>Fine</label>
            <input class="form-control" (change)="Refresh()" type="date" [(ngModel)]="filtro.fine"  [ngModelOptions]="{updateOn: 'change'}">
        </div>
        <div class="ml-auto row mr-2">
            <div>
                <button (click)="goListaBilanci()"
                class="ml-auto btn btn-success waves-effect waves-light">
                <span class="ml-1 text-white font-weight-bold"> Lista Movimenti </span>
                <i class="fa fa-arrow-left"></i>
                </button>
            </div>
            <div>
                <button *ngIf="!bilancio?.data_pagamento_p" (click)="populateFattureEffettive()"
                class="ml-auto btn btn-success waves-effect waves-light">
                <span class="ml-1 text-white font-weight-bold"> Salva </span>
                <i-feather name="save" class="feather-md "></i-feather>
                </button>
            </div>
            <div *ngIf="id_bilancio">
                <button *ngIf="!bilancio?.data_pagamento_p && !bilancio?.data_pagamento_e" (click)="changeStato('Approva')"
                class="ml-auto btn btn-success waves-effect waves-light">
                <span class="ml-1 text-white font-weight-bold"> Approva </span>
                <i class="fa fa-check"></i>
                </button>
            </div>
            <div *ngIf="id_bilancio">
                <button *ngIf="bilancio?.data_pagamento_p && !bilancio?.data_pagamento_e" (click)="changeStato('Valida')"
                class="ml-auto btn btn-success waves-effect waves-light">
                <span class="ml-1 text-white font-weight-bold"> Valida </span>
                <i class="fa fa-check"></i>
                </button>
            </div>
            <div *ngIf="id_bilancio">
                <button *ngIf="bilancio?.data_pagamento_p && !bilancio?.data_pagamento_e" (click)="changeStato('Riesamina')"
                class="ml-auto btn btn-success waves-effect waves-light">
                <span class="ml-1 text-white font-weight-bold"> Riesamina </span>
                <i class="fa fa-check"></i>
                </button>
            </div>
        </div>
    </div>
    
    <div>
        <!--<table *ngIf="dataList.length > 0 && giorniList.length > 0" class="table bg-white table-hover mt-2">
            <tr>
                <th></th>
                <th  *ngFor="let data of giorniList">
                    {{data}}
                </th>
            </tr>
            <tr>
                <th>Ospiti</th>
                <th class="text-center" *ngFor="let data of giorniList">
                    +|- <br>
                    Descrizione
                </th>
            </tr>
                <tr *ngFor="let data of dataList">
                        <td>{{data?.nome}}</td>
                        <ng-container *ngFor="let fattura of data.fattura">
                            <ng-container *ngIf="!(bilancio?.data_pagamento_p && bilancio?.data_pagamento_e && !riesamina)">
                                <td>
                                    <input class="quantita" type="number" [(ngModel)]="x.quantita" *ngFor="let x of fattura.voci" min="0" max="999">
                                    <span class="text-center" *ngIf="fattura?.id">{{fattura.voci[0].voce}}</span>
                                    <input class="name" type="text" *ngIf="!fattura?.id" (ngModelChange)="setVoce(fattura)" [(ngModel)]="fattura.voci[0].voce">
                                </td>
                            </ng-container>
                            <ng-container *ngIf="(bilancio?.data_pagamento_p && bilancio?.data_pagamento_e && !riesamina)">
                                <td>
                                    <input class="quantita" type="number" readonly="readonly" [(ngModel)]="x.quantita" *ngFor="let x of fattura.voci" min="0" max="999">
                                    <span class="text-center" *ngIf="fattura?.id">{{fattura.voci[0].voce}}</span>
                                    <input class="name" type="text" readonly="readonly" *ngIf="!fattura?.id" (ngModelChange)="setVoce(fattura)" [(ngModel)]="fattura.voci[0].voce">
                                </td>
                            </ng-container>
                        </ng-container>
                </tr>
                <tr *ngIf="id_bilancio">
                    <td>Cassa Iniziale: </td>
                    <td colspan=7>{{bilancio?.valorePrecedente}}</td>
    
                    <tr *ngIf="id_bilancio">
                        <td>Cassa Finale: </td>
                        <td colspan=7>{{bilancio?.valore}}</td>
                </tr>            
    </table>-->
<div class="table-responsive">
    <table class="table bg-white table-hover mt-2"  style="width: auto; table-layout: fixed;" *ngIf="dataList.length > 0 && giorniList.length > 0">
        <thead>
            <tr>
                <th style="position: sticky; left: 0; background-color: white; z-index: 2;" ></th>
                <th class="text-center" *ngFor="let data of giorniList" colspan="3">{{data}}</th>
            </tr>
            <tr>
                <th style="position: sticky; left: 0; background-color: white; z-index: 2;" >Ospiti</th>
                <ng-container *ngFor="let data of giorniList">
                    <th class="text-center">+</th>
                    <th class="text-center">-</th>
                    <th class="text-center">Descrizione</th>
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of dataList">
                <td style="position: sticky; left: 0; background-color: white; z-index: 2;" >{{data?.nome}}</td>
                <ng-container *ngIf="!(bilancio?.data_pagamento_p && bilancio?.data_pagamento_e && !riesamina) && !(bilancio?.data_pagamento_p && !bilancio?.data_pagamento_e)">
                    <ng-container *ngFor="let fattura of data.fattura">
                        <td>
                            <input class="quantita" type="number" [(ngModel)]="fattura.voci[0].prezzo" min="0" max="999">
                        </td>
                        <td>
                            <input class="quantita" type="number" [(ngModel)]="fattura.voci[1].prezzo" min="0" max="999">
                        </td>
                        <td>
                            <input class="name" type="text" *ngIf="!fattura?.id" (ngModelChange)="setVoce(fattura)" [(ngModel)]="fattura.voci[0].voce">
                            <span class="text-center" *ngIf="fattura?.id">{{fattura.voci[0].voce}}</span>                        
                        </td>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="(bilancio?.data_pagamento_p && bilancio?.data_pagamento_e && !riesamina) || (bilancio?.data_pagamento_p && !bilancio?.data_pagamento_e)">
                    <ng-container *ngFor="let fattura of data.fattura">
                        <td>
                            <input class="quantita" readonly type="number" [(ngModel)]="fattura.voci[0].prezzo" min="0" max="999">
                        </td>
                        <td>
                            <input class="quantita" readonly type="number" [(ngModel)]="fattura.voci[1].prezzo" min="0" max="999">
                        </td>
                        <td>
                            <input class="name" type="text" readonly *ngIf="!fattura?.id" (ngModelChange)="setVoce(fattura)" [(ngModel)]="fattura.voci[0].voce">
                            <span class="text-center" *ngIf="fattura?.id">{{fattura.voci[0].voce}}</span>                        
                        </td>
                    </ng-container>
                </ng-container>
            </tr>
        </tbody>
        <tfoot *ngIf="id_bilancio">
            <tr>
                <td>Cassa Iniziale:</td>
                <td colspan="21">{{bilancio?.valorePrecedente}}</td>
            </tr>
            <tr>
                <td>Cassa Finale:</td>
                <td colspan="21">{{bilancio?.valore}}</td>
            </tr>
        </tfoot>
    </table>
</div>
    
        <div class="row" *ngIf="id_bilancio">
            <div class="col-lg-12 row" >
                <div class="col-lg-3">
                    <label>Note in Lavorazione: </label>
                    <textarea class="form-control" readonly  rows="5" cols="3" [(ngModel)]="bilancio.note"></textarea>
                </div>
                <div class="col-lg-3" *ngIf="bilancio?.data_pagamento_p">
                    <label>Note Approvazione: </label>
                    <textarea class="form-control" readonly rows="5" cols="3" [(ngModel)]="bilancio.noteApprovazione"></textarea>
                </div> 
                <div class="col-lg-3" *ngIf="bilancio?.data_pagamento_e">
                    <label>Note Validazione: </label>
                    <textarea class="form-control" readonly  rows="5" cols="3" [(ngModel)]="bilancio.noteValidazione"></textarea>
                </div>
                <div class="col-lg-3" *ngIf="bilancio?.data_pagamento_e">
                    <label>Note Riesamina: </label>
                    <textarea class="form-control" readonly  rows="5" cols="3" [(ngModel)]="bilancio.noteRiesamina"></textarea>
                </div>
            </div>
            <div class="ml-2">
                <label>Stato: </label>
                <input class="form-control" *ngIf="!bilancio?.data_pagamento_p && !bilancio?.dataRiesamina " readonly="readonly" value="In Lavorazione"> 
                <input class="form-control" *ngIf="bilancio?.data_pagamento_p && bilancio?.data_pagamento_e" readonly="readonly" value="Validato">
                <input class="form-control" *ngIf="!bilancio?.data_pagamento_p && !bilancio?.data_pagamento_e && bilancio?.dataRiesamina" readonly="readonly" value="Riesaminare">
                <input class="form-control" *ngIf="bilancio?.data_pagamento_p && !bilancio?.data_pagamento_e" readonly="readonly" value="Approvato">
            </div>
        </div>
    
    </div>
    
    
</div>
